import * as React from "react";

export const HomePage = () => {
    return <div>Admin ...</div>
}